import Button from "components/foundation/Button";
import Modal from "components/foundation/Modal/Modal";
import React, { useMemo } from "react";
import styled from "styled-components";
// import { useSetRecoilState } from "recoil";
// import { analysisDocumentLevelState } from "store/document/analysisDocument";
import DocumentTagList from "../../DocumentTagList";
import { useTempDocumentDetailQuery } from "features/document/hooks/queries/useTempDocumentDetailQuery";
import DocumentDetailHeader from "components/document/read/common/DocumentDetailHeader";
import ContractInfoOverviewSection from "components/document/read/analysis/ContractInfoDetail/ContractInfoOverviewSection";
import DocumentDetailTagField from "components/document/read/common/DocumentDetailTagField";
import Label from "components/foundation/Label/Label";
import DocumentDetail from "components/document/read/common/DocumentDetail";
import useReselectAnalysisDoc from "features/document/hooks/create/analysis/useReselectAnalysisDoc";

interface TempDocumentModalProps {
  analysisDocUuid?: string;
}

const ContractInfoStep1Modal = ({
  analysisDocUuid,
}: TempDocumentModalProps) => {
  const { data: tempDocDetail } = useTempDocumentDetailQuery(analysisDocUuid);

  /* 태그 */
  const regionTags = useMemo(() => {
    if (!tempDocDetail) return [];

    const region = `${tempDocDetail.provinceName || ""} ${tempDocDetail.cityName || ""}`;
    return [region];
  }, [tempDocDetail]);
  const businessTags = useMemo(() => {
    if (!tempDocDetail) return [];

    return tempDocDetail.tags
      .filter((tag) => tag.categoryName === "사업구분")
      .map((tag) => tag.tagName);
  }, [tempDocDetail]);

  /* 재선택 버튼 */
  /* 문서 태그 초기화 */
  const { onClickReselectAnalysisDoc } = useReselectAnalysisDoc({
    tempDocumentUuid: analysisDocUuid,
  });

  // const setDocumentLevel = useSetRecoilState(analysisDocumentLevelState);

  return (
    <ModalLayoutStyle>
      <ModalContentStyle>
        {tempDocDetail && (
          <>
            <DocumentDetailHeader
              documentClassName={tempDocDetail.documentClassName}
              companyName={tempDocDetail.companyName}
            />
            <DocumentTagList
              docTags={{
                지역: regionTags,
                사업구분: businessTags,
              }}
              actions={
                <Button
                  disabled
                  variant="tertiary"
                  onClick={onClickReselectAnalysisDoc}
                >
                  재선택
                </Button>
              }
            />
            <div>
              <ContractInfoOverviewSection
                documentData={tempDocDetail.documentData}
              />

              <DocumentDetailTagField label="자유태그">
                <FreeTagContainerStyle>
                  {tempDocDetail.freeTags.map((tag) => (
                    <Label key={tag.uuid} variant="grey">
                      {tag.name}
                    </Label>
                  ))}
                </FreeTagContainerStyle>
              </DocumentDetailTagField>

              <DocumentDetail.AttachmentList
                withoutCard
                attachmentList={tempDocDetail.attachments}
              />

              {/* <FooterStyle>
                <GoToLevel1ButtonStyle
                  disabled
                  size="large"
                  onClick={() => setDocumentLevel(0)}
                >
                  1차 내용 수정
                </GoToLevel1ButtonStyle>
              </FooterStyle> */}
            </div>
          </>
        )}
      </ModalContentStyle>
    </ModalLayoutStyle>
  );
};

export default ContractInfoStep1Modal;

/* 스타일 */
const ModalLayoutStyle = styled(Modal.Layout)`
  width: 100.5rem;
  padding: 7rem 5rem 5rem 5rem;
`;

const ModalContentStyle = styled.div`
  margin: 0;

  display: flex;
  flex-direction: column;
  gap: 5rem;
  overflow-y: scroll;
  scrollbar-width: none;
`;

const FreeTagContainerStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

// const FooterStyle = styled.footer`
//   margin-top: 5rem;
//   display: flex;
//   justify-content: center;
// `;

// const GoToLevel1ButtonStyle = styled(Button)`
//   width: 20rem;
// `;
